import { observable, action, makeObservable } from 'mobx';
import { userService } from 'config/ioc';
import { PENDING, FULFILLED, REJECTED } from 'constants/actions';

type FetchState = typeof PENDING | typeof FULFILLED | typeof REJECTED;

export interface User {
  jobTitle?: string;
  salesOrganization?: {
    id?: string;
  };
  uname?: string;
  username?: string;
  [key: string]: unknown;
}

interface UserResponse {
  data: {
    data: {
      items: User[];
    };
  };
}

class UserStore {
  user: User = {};

  userFetchState?: FetchState;

  constructor() {
    makeObservable(this, {
      user: observable.ref,
      userFetchState: observable,
      getUser: action.bound,
      updateUser: action.bound,
      setUser: action.bound,
    });
  }

  async getUser(): Promise<void> {
    await this.updateUser();
  }

  async updateUser(): Promise<void> {
    this.userFetchState = PENDING;

    try {
      const response = (await userService.getUser()) as UserResponse;
      const [userData] = response.data.data.items;
      this.setUser(userData);
    } catch (e) {
      this.userFetchState = REJECTED;
    }
  }

  setUser(user: User): void {
    this.user = { ...this.user, ...user };
    this.userFetchState = FULFILLED;
  }
}

const userStore = new UserStore();

export default userStore;
